module.exports = __webpack_public_path__ + "img/14.2a0da135.jpg";